export function convertTimestampToSeconds(timestamp: string) {
  const [hours, minutes, seconds] = timestamp.split(':');
  return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
}

export const matchesTimeRegex = (timestamp?: string) => {
  if (!timestamp) {
    return false;
  }
  const regex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
  return regex.test(timestamp);
};
